var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"e-title"},[_c('div',{staticClass:"title-name"},[_vm._v(" "+_vm._s(_vm.data.content)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }